<template>
  <div>
    <UiModal 
      :open="status_show_popup" 
      @close="popupHide()"
      >
      <div class="p-4">
        <h5>
          {{lg('',{
            en: 'Select',
            zh: '',
          })}}
        </h5>
        <div class="mt-3 p-1" style="max-height: 300px; overflow: auto;">
          <div v-for="(item,index) of list_horse_my.filter(i => !i.is_male)" :key="index" class="mb-3">
            <horseItem 
              :class="{'selected': item.tokenID === form_horse_my.tokenID}"
              @horseItemClicked="selectHorseToForm"
              :data="item"
              :cfg_hide_more="true"
              :cfg_size_small="true"
            />
          </div>
        </div>
        <div class="mt-4 text-center">
          <span 
            @click="action_select()"
            class="btn btn-primary"
            >
            {{lg('',{
              en: 'Select',
              zh: '',
            })}}
          </span>
        </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import horseItem from '../_cp_busi/horse_item.vue'

export default {
  name: 'popupSelectMate',
  components: {
    horseItem,
  },
  props: [
    'cfg_show',
  ],
  data() {
    return {
      status_show_popup: false,

      list_horse_my: [],

      // 
      form_horse_my: {},
    }
  },
  computed: {
  //  data(){
  //    return this.$store.state.dataBus.data_on_select_mate
  //  },
   address_my(){
     return this.$store.state.web3.account
   },
  },
  watch: {
    'cfg_show'(val){
      this.status_show_popup = val
    },
    // 'data'(val){
    //   if(val){
    //     this.popupShow()
    //   }
    //   else{
    //     this.status_show_popup_breed = false
    //     this.clearForm()
    //   }
    // },
    'status_show_popup'(val){
      if(!val){
        // this.$store.commit('setDataBusKey',{
        //   data_on_select_mate: null,
        // })
      }
    },
    'address_my'(val){
      if(val){
        this.run()
      }
    },
  },
  methods: {
    ...mapActions([
      'getUserAllHorse',
      'bid'
    ]),

    action_select(){
      let v = this

      if(!v.form_horse_my.tokenID){
        return
      }

      v.$store.commit('setDataBusKey',{
        data_on_select_mate_female: v.form_horse_my,
      })

      v.popupHide()
    },

    selectHorseToForm(data){
      this.form_horse_my = data
    },

    clearForm(){
      this.form_horse_my = {}
    },
    popupHide(){
      this.status_show_popup = false
      this.$emit('close')
    },
    popupShow(){
      this.status_show_popup = true
    },

    async listMyHorse(){
      let v = this
      if(!v.address_my){
        return
      }
      const res = await v.getUserAllHorse({
        address_my: v.address_my,
      })

      let res_new = res.map(item => {
        let item_new = v.transHorseData(item)
        item_new.is_my = true
        return item_new
      })
      console.log('...')
      console.log(res_new)
      v.list_horse_my = res_new
    },

    run(){
      this.listMyHorse()
    },
  },
  created() {
    this.run()
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>